<script lang="ts">
	// Stores
	import { device_ui } from 'src/stores/features/device-ui';

	// Helpers and registry
	import { getCurrentView } from 'src/components/Sidepanel/view-helpers';
	import { viewComponentRegistry } from 'src/components/Sidepanel/view-registry';

	// Types
	import type { Device } from 'src/types/Device';

	export let device: Device;

	$: view = getCurrentView(device, $device_ui);
	$: component =
		viewComponentRegistry?.[view.category]?.[view.variant] ??
		viewComponentRegistry?.['pill_sensor']?.['basic'];
</script>

{#if component}
	<svelte:component this={component} {device} />
{/if}
